import request from '@/utils/request'

// 结算货币列表（来自 sys_currency）
export function moneyCofig() {
  return request({
    url: '/config/moneyconfig',
    data: { "config": "1" },
    method: 'post',
    headers: {
      repeatSubmit: false
    }
  })
}

/**
 * 国家列表（来自 sys_country 字典）
 * 返回 [{ code: "BR", codeIso3: "BRA", nameCn: "巴西", nameEn: "Brazil" }]，
 * 全系统统一以 code（ISO 3166-1 alpha-2）作为存储与计费匹配值，
 * 与 WMS 收费分区、超长超重规则、订单 recipientCountry 同口径
 */
export function countryConfig() {
  return request({
    url: '/config/country/list',
    method: 'get'
  })
}
